import React from "react";
import "./Experience.css";

export default function Experience() {
  return (
    <section id="experience">
      <h2>Experience</h2>
      <div className="timeline">
        <div className="timeline-item neumorphic">
          <h3>Intern Software Engineer - Shield Technologies (PVT) Ltd</h3>
          <p>2025</p>
          <ul>
            <li>Developed and optimized cross-platform mobile applications using Flutter and Firebase.</li>
            <li>Implemented Firebase Authentication and database features for secure and efficient user data management.</li>
            <li>Designed and built responsive, user-friendly UI/UX with smooth performance across devices and screen sizes.</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
